/* global yaCounterNUMBERID */
import helpers from '../helpers';
import scrollDepth from 'scroll-depth';

function start15SecTimeout() {
	clearTimeout(helpers.$window.data('timeout15Sec'));

	helpers.$window.data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function clearText(text) {
	return text.toString().trim().replace(/\s+/g, ' ');
}

function isClientLink(href) {
	let value = false;

	clienLinks.forEach((link) => {
		if (href.indexOf(link) >= 0) {
			value = true;
		}
	});

	return value;
}

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	},
});

/**
* Создать куки запись
* @param {string} path Обязательное, ссылка/путь
*/
function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		// Не всегда используются
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}
}

function init() {
	const $showOnScrollElements = $('.js-banner, .js-test, .js-cards');

	const showElementsOnScroll = () => {
		const scrollTop = helpers.$window.scrollTop();
		const scrollBottom = scrollTop + innerHeight;

		$showOnScrollElements
			.filter(':visible')
			.each((index, element) => {
				const $element = $(element);

				const elementOffsetTop = $element.offset().top;
				const elementOffsetBottom = elementOffsetTop + $element.outerHeight();

				if (scrollBottom >= elementOffsetTop && scrollTop <= elementOffsetBottom && !$element.data('showed')) {
					$element.data('showed', true);

					if ($element.hasClass('cards__item')) {
						const num = clearText($element.find('.cards__number').text());

						ga('send', 'event', 'cards', 'show', num, {nonInteraction: true});
					} else if ($element.hasClass('cards__banner')) {
						ga('send', 'event', 'banner', 'show', 'bottom banner', {nonInteraction: true});
					} else if ($element.hasClass('js-banner')) {
						const type = $element.data('type');

						ga('send', 'event', 'banner', 'show', `${type} banner`, {nonInteraction: true});
					} else if ($element.hasClass('js-test')) {
						ga('send', 'event', 'article test', 'question show 1', `${$element.find('.article-test__step[data-number="1"]').find('.article-test__ask').text()}`, {nonInteraction: true});
					}
				}
			});
	};

	$showOnScrollElements.data('showed', false);

	helpers.$window.on('scroll', showElementsOnScroll);



	$('.header__logo-partner').on('click', () => {
		ga('send', 'event', 'client link', 'logo header');
		ga('rbcspec.send', 'event', 'client link', 'click');
	});

	$('.header__logo-rbc').on('click', () => {
		ga('send', 'event', 'nav', 'rbc logo');
	});

	$('.article-fixedMenu__item').on('click', (e) => {
		const $this = $(e.currentTarget);
		ga('send', 'event', 'nav', 'menu item click', $this.text());
		helpers.$document.trigger('close-menu');
	});

	$('.home-block__solution a, .home-block__desc a, .home-main-footer__text a').on('click', (e) => {
		const name = clearText(e.currentTarget.textContent);

		if (isClientLink(e.currentTarget.getAttribute('href'))) {
			ga('send', 'event', 'client link', 'article text link', name);
			ga('rbcspec.send', 'event', 'client link', 'click');
		} else {
			ga('send', 'event', 'article', 'text link', name);
		}
	});

	$('.test-questions__result-text a').on('click', (e) => {
		const name = clearText(e.currentTarget.textContent);

		if (isClientLink(e.currentTarget.getAttribute('href'))) {
			ga('send', 'event', 'client link', 'test question link', name);
			ga('rbcspec.send', 'event', 'client link', 'click');
		}
	});

	$('.test-results__text a').on('click', (e) => {
		const name = clearText(e.currentTarget.textContent);

		if (isClientLink(e.currentTarget.getAttribute('href'))) {
			ga('send', 'event', 'client link', 'test final link', name);
			ga('rbcspec.send', 'event', 'client link', 'click');
		}
	});

	$('.home-content__go-test').on('click', () => {
		ga('send', 'event', 'article', 'go to test');
	});

	$('.home-timer__btn').on('click', () => {
		ga('send', 'event', 'article', 'download instruction');
	});

	$('.js-test-restart').on('click', () => {
		ga('send', 'event', 'test', 'resume');
	});


	$('.js-banner').on('click', (e) => {
		const type = clearText($(e.currentTarget).data('type'));
		const name = clearText($(e.currentTarget).data('name'));

		ga('send', 'event', 'client link', 'banner click', `${type} banner - ${name}`);
		ga('rbcspec.send', 'event', 'client link', 'click');
	});

	$('.footer-share-info__text').on('click', (e) => {
		const name = clearText(e.currentTarget.dataset.social);

		ga('send', 'event', 'share', 'project share', name);
	});

	function triggersInit() {
		if (!eventsTrigger) {
			helpers.$document.on('test-start', () => {
				ga('send', 'event', 'test', 'start', '', {nonInteraction: true});
				ga('rbcspec.send', 'event', 'test', 'start', {nonInteraction: true});
			}).on('test-question-show', (e, stepIndex, question) => {
				ga('send', 'event', 'test', `question show ${stepIndex}`, clearText(question), {nonInteraction: true});
			}).on('test-answer', (e, stepIndex, question, isCorrect) => {
				ga('send', 'event', 'test', `question answer ${stepIndex}`, clearText(question), isCorrect);
			})
				.on('test-result', (e, result) => {
					ga('send', 'event', 'test', 'finish', result);
					ga('rbcspec.send', 'event', 'test', 'finish', result);
				})
				.on('test-reload', () => {
					ga('send', 'event', 'test', 'resume');
				})
				.on('slider-change', () => {
					ga('send', 'event', 'article', 'slider change');
				})
				.on('quiz-question-show', (e, stepIndex, question) => {
					ga('send', 'event', 'article test', `question show ${stepIndex}`, clearText(question), {nonInteraction: true});
				})
				.on('quiz-result', (e, result) => {
					ga('send', 'event', 'article test', 'finish', result);
					ga('rbcspec.send', 'event', 'article test', 'finish', result);
				})
				.on('audio-play', (e, name) => {
					ga('send', 'event', 'audio', 'play', name, {nonInteraction: false});
				})
				.on('audio-end', (e, name) => {
					ga('send', 'event', 'audio', 'finish', name);
				})
				.on('audio-30-sec', (e, name) => {
					ga('send', 'event', 'audio', 'timing 30s', name, 30);
				})
				.on('video-play', (e, name) => {
					ga('send', 'event', 'video', 'play', name, {nonInteraction: true});
					ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});
				})
				.on('video-end', (e, name) => {
					ga('send', 'event', 'video', 'finish', name);
					ga('rbcspec.send', 'event', 'video', 'finish');
				})
				.on('video-10-sec', (e, name) => {
					ga('send', 'event', 'video', 'timing 30s', name, 30);
					ga('rbcspec.send', 'event', 'video', 'timing 30s', '', 30);
				});
		}
	}

	// triggersInit();

}

export default {
	start15SecTimeout,
	init,
	virtualHit,
};
